








import Vue, { VNode } from 'vue';

export default Vue.extend({
  name: 'Code',
  props: {
    highlight: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      highlightedCode: '',
    };
  },
  methods: {
    jsonHighlight(json: string) {
      json = `${json}`;
      json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      // tslint:disable-next-line
      return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function(match) {
        let cls = 'number';
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key';
          } else {
            cls = 'string';
          }
        } else if (/true|false/.test(match)) {
          cls = 'boolean';
        } else if (/null/.test(match)) {
          cls = 'null';
        }
        return '<span class="' + cls + '">' + match + '</span>';
      });
    },
    applyHighlight() {
      if (this.$scopedSlots.default &&
        this.$scopedSlots.default(null) &&
        (this.$scopedSlots.default(null) as VNode[]).length > 0) {
        const contents = (this.$scopedSlots.default(null) as VNode[])[0].text;
        if (contents) {
          if (this.highlight === 'json') {
            this.highlightedCode = this.jsonHighlight(contents.trim());
          } else {
            this.highlightedCode = contents.trim();
          }
        }
      }
    },
  },
  mounted() {
    this.applyHighlight();
  },
  updated() {
    this.applyHighlight();
  },
});
